import styles from "./in-memory-warning.module.scss";

export interface InMemoryWarningProps {
  /** Whether the app is running in in-memory (non-persistent) mode */
  isInMemory: boolean;
}

/**
 * Subtle caution icon for the app header that warns when the browser
 * doesn't support persistent storage. On hover/focus, shows a tooltip
 * explaining the limitation. Not dismissible — the condition won't change.
 */
export function InMemoryWarning({ isInMemory }: InMemoryWarningProps) {
  if (!isInMemory) return null;

  return (
    <span className={styles.wrapper}>
      <span className={styles.icon} aria-label="Storage warning" tabIndex={0}>
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
          <line x1="12" y1="9" x2="12" y2="13" />
          <line x1="12" y1="17" x2="12.01" y2="17" />
        </svg>
      </span>
      <span className={styles.tooltip} role="tooltip">
        Your browser doesn&rsquo;t support persistent storage. Data will be lost when you close this
        tab. Use Chrome, Edge, or Firefox for the full experience.
      </span>
    </span>
  );
}
